import { PROVINSI, KABUPATEN, KECAMATAN, KELURAHAN, MONTHS } from "../constants";
import { decompress } from "lz-string";

export const axiosConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

export const provinsi = () => {
  const p = localStorage.getItem(PROVINSI);
  return JSON.parse(decompress(p));
};

export const kabupaten = () => {
  const p = localStorage.getItem(KABUPATEN);
  return JSON.parse(decompress(p));
};
export const kecamatan = () => {
  const p = localStorage.getItem(KECAMATAN);
  return JSON.parse(decompress(p));
};
export const kelurahan = () => {
  const p = localStorage.getItem(KELURAHAN);
  return JSON.parse(decompress(p));
};
export const isBiro = () => {
  const u = localStorage.getItem("user");
  const user = JSON.parse(u);
  if (user == null) return false;
  return user.role * 1 < 4;
};

export const isBiroOnly = () => {
  const u = localStorage.getItem("user");
  const user = JSON.parse(u);
  if (user == null) return false;
  return user.role * 1 === 3;
}

export const dateIndo = (d) => {
  const date = new Date(d);

  const tahun = date.getFullYear();
  const bulan = date.getMonth();
  const tanggal = date.getDate();

  return `${tanggal} ${MONTHS[bulan]} ${tahun}`;
};


export const satuan = number => {
  if (number == null) {
    return 0;
  }
  if (number == 0) {
    return 0;
  }
  var unitlist = ['', 'rb', 'jt', 'M', 'T'];
  let sign = Math.sign(number);
  let unit = 0;

  var xxx = Math.abs(number);
  if (xxx < 1000) {
    return xxx.toFixed(2);
  }

  while (Math.abs(number) >= 1000) {
    unit = unit + 1;
    number = Math.floor(Math.abs(number) / 100) / 10;
  }
  return sign * Math.abs(number) + unitlist[unit];
};



export const singkatan_nama_perusahaan = nama => {
  var singkatan = 'tidak ditemukan singkatan'
  if (nama == 'PT Agro Jabar') singkatan = 'AGJ'
  if (nama == 'PT Agronesia') singkatan = 'AGN'
  if (nama == 'PT BIJB') singkatan = 'BIJ'
  if (nama == 'PT Jasa Sarana') singkatan = 'JSN'
  if (nama == 'PT Jaswita') singkatan = 'JSW'
  if (nama == 'PT Migas Hilir Jabar') singkatan = 'MRJ'
  if (nama == 'PT Migas Hulu Jabar') singkatan = 'MUJ'
  if (nama == 'PT Migas Utama Jabar') singkatan = 'MUJ'
  if (nama == 'PT Tirta Gemah Ripah') singkatan = 'TGR'
  if (nama == 'PD Agribisnis dan Pertambangan') singkatan = 'PDAP'
  return singkatan
};


export const indikator_color = nama => {
  var color = '#507B3C'
  if (nama == 'SANGAT SEHAT') color = '#507B3C'
  if (nama == 'SEHAT') color = '#507B3C'
  if (nama == 'CUKUP SEHAT') color = '#507B3C'
  if (nama == 'KURANG SEHAT') color = '#BDCB1C'
  if (nama == 'TIDAK SEHAT') color = '#DC3832'
  return color
};

export const rkapPercentage = (realisasi, rkap) => {
  if (realisasi || rkap) {
    return isNaN(parseFloat(((realisasi) / rkap) * 100).toFixed(1)) ? "-" : parseFloat(((realisasi) / rkap) * 100).toFixed(1);
  }
  return "-";
};
